<p-dropdown [options]="agentsList" optionValue="code" [(ngModel)]="selectedAgent" optionLabel="name" placeholder="Select Agent" styleClass="w-100"
[filter]="true"
filterBy="name">
    <ng-template let-opt pTemplate="selectedItem">
        {{ opt?.name }}
    </ng-template>
</p-dropdown>
<div class="flex flex-column justify-content-end align-items-end">
    <button [loading]="loading" (click)="onSubmit()" pButton pRipple label="Save" icon="pi pi-check" class="p-button-text mt-2"></button>
</div>
